import { API_BASE_URL } from "@/lib/api/config";

const MEDIA_BACKEND_ORIGIN = new URL(API_BASE_URL).origin;

export const getMediaUrl = (pathOrKey: string | null | undefined): string | null => {
  if (!pathOrKey) return null;
  if (/^https?:\/\//i.test(pathOrKey) || pathOrKey.startsWith("blob:") || pathOrKey.startsWith("data:")) {
    return pathOrKey;
  }

  const cleanPath = pathOrKey.replace(/^\/+/, "");

  if (cleanPath.startsWith("static/")) {
    return `${MEDIA_BACKEND_ORIGIN}/${cleanPath}`;
  }

  if (cleanPath.startsWith("uploads/")) {
    return `${MEDIA_BACKEND_ORIGIN}/static/${cleanPath}`;
  }

  return `${MEDIA_BACKEND_ORIGIN}/static/uploads/${cleanPath}`;
};

export const resolveMediaUrl = getMediaUrl;
export const formatImageUrl = getMediaUrl;
